import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

export default function QuestionsFeature() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/questions?limit=6").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <section data-testid={T.questionsFeature} className="bg-subtle border-y border-border py-20 sm:py-28">
      <div className="container-editorial">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-12">
          <div>
            <span className="eyebrow">Questions you may be asking</span>
            <h2 className="heading-2 mt-3">Honest questions, careful answers.</h2>
          </div>
          <Link to="/questions" className="text-sm uppercase tracking-widest text-ink hover:text-forest">
            Browse all questions →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((q) => (
            <Link
              key={q.slug}
              to={`/questions/${q.slug}`}
              data-testid={T.questionCard(q.slug)}
              className="group bg-paper border border-border p-7 hover:border-ink transition-colors flex flex-col"
            >
              <span className="eyebrow text-forest">{q.category}</span>
              <h3 className="font-serif text-2xl mt-3 text-ink leading-tight group-hover:text-forest transition-colors" style={{ fontWeight: 500 }}>
                {q.question}
              </h3>
              <p className="text-sm mt-4 text-ink-muted leading-relaxed flex-1">
                {q.short_answer.length > 220 ? `${q.short_answer.slice(0, 220)}…` : q.short_answer}
              </p>
              <span className="mt-6 text-xs uppercase tracking-widest text-ink group-hover:text-forest">Read more →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
